var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailwind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      background: "white"
    },
    width: 54,
    height: 54,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    clipPath: "url(#prefix__clip0)",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    clipRule: "evenodd",
    d: "m27,10.8c-7.2,0 -11.7,3.6 -13.5,10.8c2.7,-3.6 5.85,-4.95 9.45,-4.05c2.054,0.513 3.522,2.004 5.147,3.653c2.647,2.687 5.711,5.797 12.403,5.797c7.2,0 11.7,-3.6 13.5,-10.8c-2.7,3.6 -5.85,4.95 -9.45,4.05c-2.054,-0.513 -3.522,-2.004 -5.147,-3.653c-2.647,-2.687 -5.711,-5.797 -12.403,-5.797zm-13.5,16.2c-7.2,0 -11.7,3.6 -13.5,10.8c2.7,-3.6 5.85,-4.95 9.45,-4.05c2.054,0.514 3.522,2.004 5.147,3.653c2.647,2.687 5.711,5.797 12.403,5.797c7.2,0 11.7,-3.6 13.5,-10.8c-2.7,3.6 -5.85,4.95 -9.45,4.05c-2.054,-0.513 -3.522,-2.004 -5.147,-3.653c-2.647,-2.687 -5.711,-5.797 -12.403,-5.797z",
    fillRule: "evenodd",
    fill: "#06B6D4",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#1f2937",
    strokeWidth: "null",
    strokeDasharray: "null",
    strokeLinejoin: "null",
    strokeLinecap: "null",
    x: 45,
    y: 0,
    width: 9,
    height: 54,
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4b5563",
    strokeWidth: "null",
    strokeDasharray: "null",
    strokeLinejoin: "null",
    strokeLinecap: "null",
    x: 45,
    y: 0,
    width: 9,
    height: 28,
    id: "svg_4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.5e2a45a11e73e5dc90e6c56fbb47b22b.svg";
export { ForwardRef as ReactComponent };